import { render, staticRenderFns } from "./ApiBlock.vue?vue&type=template&id=3230b7ce&scoped=true"
import script from "./ApiBlock.vue?vue&type=script&lang=js"
export * from "./ApiBlock.vue?vue&type=script&lang=js"
import style0 from "./ApiBlock.vue?vue&type=style&index=0&id=3230b7ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3230b7ce",
  null
  
)

export default component.exports